<header>
    <div class="wrap">
        <div class="text">
            <h2 class="title">{{ 'popins.products_list.main.assistance.title' | translate }}</h2>
        </div>
        <div class="header-actions">
            <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
                <span class="icon-view-close" aria-hidden="true">
                    <svg>
                        <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
                    </svg>
                </span>
                <span>{{ 'generic.close' | translate }}</span>
            </button>
        </div>
    </div>
</header>
<div class="main">
    <div class="inner-content">     
        <div class="assistance-container">    
            <div class="assistance-card shadow"
                 *ngFor="let assistance of assistances"
                 [ngClass]="{'active': isAssistanceSelected(assistance.id)}"
                 (click)="selectAssistance(assistance)"
                 (mouseenter)="checkAssistance(assistance.id)"
                 (mouseleave)="uncheckAssistance(assistance.id)">    
    
                <p class="assistance-title form-check form-check-inline">
                    <input class="form-check-input"
                           type="checkbox"
                           id="title-{{ assistance.id }}"
                           [checked]="isAssistanceSelected(assistance.id)">
                    <label class="form-check-label">
                        {{ assistance.type }}
                    </label>
                </p>
                
                <div class="form-group assistance-price">
                  <label for="price-{{ assistance.id }}">{{ 'popins.products_list.main.assistance.price' | translate }}</label>
                  <input type="number"
                         [min]="1"
                         class="form-control form-control-sm"
                         id="price-{{ assistance.id }}"
                         [value]="getAssistancePrice(assistance.id)"
                         (click)="$event.stopPropagation()"
                         (change)="updatePrice($event, assistance.id)"
                         [disabled]="!isAssistanceSelected(assistance.id)">
                </div>
            </div>    
        </div>  
        <div class="text-center">
            <ng-hbm-bdi-btn class="light-grey mr-3"  [hidden]="isLoading"
                (click)="cancel()" [label]="'generic.cancel' | translate">
            </ng-hbm-bdi-btn>
            <ng-hbm-bdi-btn [disabled]="isConfirmDisabled()" class="primary" [loading]="isLoading"
                [label]="'generic.ok' | translate"  
                (click)="confirm()" >
            </ng-hbm-bdi-btn>
        </div>     
    </div>         
</div>


